import { render, staticRenderFns } from "./unsubscribeForm.vue?vue&type=template&id=31bd9d59&scoped=true&"
import script from "./unsubscribeForm.vue?vue&type=script&lang=ts&"
export * from "./unsubscribeForm.vue?vue&type=script&lang=ts&"
import style0 from "./unsubscribeForm.vue?vue&type=style&index=0&id=31bd9d59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd9d59",
  null
  
)

export default component.exports